import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Shop by Category
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            Jump to curated CSSBuy product spreadsheets organized across every major category
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 hover:bg-accent-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className="ri-shopping-bag-3-line text-accent-600 text-xl"></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 text-center leading-tight group-hover:text-accent-700 transition-colors">
                {cat.name}
              </span>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-xs text-foreground-500">
            All categories link to verified seller spreadsheets on kaspreadsheet.com
          </p>
        </div>
      </div>
    </section>
  );
}